import sk from 'Console/localization/sk/index';
import en from 'Console/localization/en/index';

export default {
    en,
    sk,
};
